import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(lobby)/LobbyLayoutClient.tsx");
